module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/about/neil_brewer.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/img/about/neil_brewer.jpg
// module id = wNr4
// module chunks = 0